import apiClient from './client'

export interface ExplorerItem {
  name: string
  type: 'file' | 'folder'
  path?: string      // For folders
  size?: number      // For files (bytes)
  last_modified?: string  // For files (ISO timestamp)
  url?: string       // For files (relative URL)
}

export interface ExplorerListResponse {
  success: boolean
  path: string
  items: ExplorerItem[]
  message?: string
}

export interface ExplorerMkdirResponse {
  success: boolean
  folder_path: string
  message: string
}

export interface ExplorerDeleteResponse {
  success: boolean
  message: string
}

/**
 * List files and folders in S3 bucket
 */
export const listExplorer = async (path?: string): Promise<ExplorerListResponse> => {
  const params = path ? { path } : {}
  const response = await apiClient.get<ExplorerListResponse>('/explorer/list', { params })
  return response.data
}

/**
 * Create new folder
 */
export const createFolder = async (
  parentPath: string,
  folderName: string
): Promise<ExplorerMkdirResponse> => {
  const response = await apiClient.post<ExplorerMkdirResponse>('/explorer/mkdir', {
    path: parentPath,
    folder_name: folderName
  })
  return response.data
}

/**
 * Delete file or folder
 */
export const deleteItem = async (
  path: string,
  type: 'file' | 'folder'
): Promise<ExplorerDeleteResponse> => {
  const response = await apiClient.delete<ExplorerDeleteResponse>('/explorer/delete', {
    data: { path, type }
  })
  return response.data
}
